import React, { useContext, useMemo } from 'react'
import { IAlertBio } from '@/api/notification/getNotificationBio.ts'
import { format } from 'date-fns'
import GreenIcon from '@/assets/img__bio_alert__green.svg?react'
import RedIcon from '@/assets/img__bio_alert__red.svg?react'
import { BioAlertModalContext } from '@/pages/notification/bio/BioAlertModal.tsx'
import { useTranslation } from 'react-i18next'
import useQueryGetMe from '@/api/auth/getMe.ts'

export interface IProps extends IAlertBio {
    className?: string
}

const BioAlertItem: React.FC<IProps> = ({ className, protectee, alert, id }) => {
    const { t } = useTranslation()
    const { data: me } = useQueryGetMe()
    
    // 특정 이메일 계정인지 확인
    const isMaskingRequired = useMemo(() => {
        return me?.email === 'dbd_cm@clomental.com'
    }, [me?.email])
    
    // 마스킹 처리 함수
    const getMaskedName = (name?: string) => {
        if (!isMaskingRequired || !name) return name
        if (name.length <= 1) return name
        return name.charAt(0) + '**'
    }

    const renderStatusIcon = useMemo(() => {
        if (alert?.taskManagerAt) {
            return <GreenIcon />
        } else {
            return <RedIcon />
        }
    }, [alert?.taskManagerAt])

    const { id: selectedId, setId } = useContext(BioAlertModalContext)

    const isSelected = useMemo(() => {
        return id == selectedId
    }, [id, selectedId])

    return <button
        type="button"
        className={[
            className || '',
            'bio-alert-item',
            isSelected ? 'is-selected' : '',
            alert?.isMyTask && selectedId !== id ? 'is-my-task' : ''
        ].filter(Boolean).join(' ')}
        onClick={() => setId(id)}>
        <span className="bio-alert-item__status">{renderStatusIcon}</span>
        <span className="bio-alert-item__content">
            <strong>{getMaskedName(protectee?.name)}</strong>
            <small>{t('notification.v2.bioItem.detectedAt', { time: format(alert?.createdAt, 'HH:mm:ss') })}</small>
        </span>
        <span className="bio-alert-item__type">
            {alert?.taskManagerAt ? t('notification.bioModal.list.item.allotment') : t('notification.bioModal.list.item.new')}
        </span>
        <span className="bio-alert-item__arrow" aria-hidden>›</span>
    </button>
}

export default BioAlertItem
